import { Theme } from '@mui/material/styles'
import makeStyles from '@mui/styles/makeStyles'

export default makeStyles((theme: Theme) => ({
  editor: {
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(4),
    minHeight: 320
  }
}))
